import React, { useState } from "react";
import Contacts from "@/pages/contacts";
const Canadastudentvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/cannads.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          {/* <div className="absolute bottom-5 left-5 text-3xl font-bold text-[#011473] drop-shadow-md">
          Canada student visa
          </div> */}
        </div>
      </div>
      <div className=" mt-10 w-full text-left text-3xl font-bold text-[#011473] drop-shadow-md sm:ml-16 sm:w-3/4 sm:text-4xl lg:ml-32">
        Canada Student Visa & Study Permit
      </div>
      <div className=" mt-5 w-full text-left text-base font-bold text-gray-800 drop-shadow-md sm:ml-16 sm:w-3/4 sm:text-md lg:ml-32">
        Canada is a top choice for international students seeking higher
        education, offering world-class universities and high-quality academic
        programs. With its internationally recognized degrees and exceptional
        curriculum, Canada provides an ideal environment for learning. A study
        permit (Canada student visa) is required for students planning to study
        for more than six months. However, those enrolled in programs of six
        months or less are exempt from this requirement.
      </div>
      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}
        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/studentt.jpg" // Replace with the correct path to your image
            alt="Canada Student Visa Requirements"
            className="w-2/2 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-black font-bold">Valid Passport:</a> Ensure your passport is valid for at least six
              months from the date of your application.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Letter of Acceptance:</a> A formal acceptance letter from a Designated
              Learning Institution (DLI) in Canada is mandatory.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Proof of Financial Support: </a>Submit bank statements, scholarship
              details, or other financial documents that prove you can cover
              tuition fees and living expenses.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">  Passport-Sized Photos:</a> Recent passport-size photographs meeting
              the exact specifications outlined by Immigration, Refugees and
              Citizenship Canada (IRCC).
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Immigration Medical Examination (IME): </a>Obtain a medical
              examination report from an IRCC-approved panel physician.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Police Clearance Certificate:</a> Certificates confirming you have no
              criminal record, issued by authorities in all countries where you
              have resided for six months or more after turning 18.
            </span>
          </div>
        </div>
      </div>
      <div className=" mr-10 space-y-4 sm:ml-16 lg:ml-32">
        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-md">
          <a className="text-black font-bold"> Statement of Purpose (SOP): </a>A well-drafted letter explaining your
            study objectives, reasons for selecting your course and institution
            and future career aspirations.
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-md">
          <a className="text-black font-bold">Language Proficiency Proof:</a> English proficiency (IELTS/TOEFL) or
            French proficiency (TEF/TCF) test results as required by your
            program.
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-md">
          <a className="text-black font-bold">Academic Records: </a>Copies of academic transcripts, including
            certificates for high school and any post-secondary education
            completed.
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-md">
          <a className="text-black font-bold">  Custodian Declaration (For Minors): </a> A document signed by your
            custodian in Canada, applicable if you are under 18 years of age.
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-md">
          <a className="text-black font-bold">Payment Receipts:</a> Evidence of payment for visa application fees and
            any tuition fees already submitted.
          </span>
        </div>
      </div>
       <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
        <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-4xl">
          Essential Documents for Applying for a Canadian Study Permit
        </p>
        <div className="container mx-auto mb-10 mt-14">
  <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 xl:grid-cols-3">
    {[
      {
        href: "#", // Update this if needed
        title: "Valid Passport",
        description: "Ensure that your passport remains valid for a minimum of six months from the application submission date.",
        imgSrc: "/turist.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Acceptance Letter",
        description: "Submit an official letter of acceptance from a recognized Designated Learning Institution (DLI) in Canada.",
        imgSrc: "/bussines.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Proof of Financial Capability",
        description: "Provide supporting financial documents such as recent bank statements or sponsorship letters, demonstrating that you have sufficient funds to cover tuition, living expenses and travel costs.",
        imgSrc: "/visits.JPG",
      },
      {
        href: "#", // Update this if needed
        title: "Recent Passport-Sized Photos",
        description: "Include recent passport-sized photographs that meet the specifications outlined by Immigration, Refugees and Citizenship Canada (IRCC).",
        imgSrc: "/students.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Medical Examination Report",
        description: "Undergo a medical examination by a doctor approved by IRCC and provide the official medical report.",
        imgSrc: "/medical.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Language Proficiency Evidence",
        description: "Submit the results of an approved language proficiency test, such as IELTS/TOEFL for English or TEF/TCF for French, depending on the language requirements of your program.",
        imgSrc: "/stay.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Statement of Purpose",
        description: "Provide a detailed letter outlining your academic goals, reasons for choosing your specific program and institution, and your long-term career aspirations.",
        imgSrc: "/passports.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Academic Records",
        description: "Present certified copies of your educational transcripts and certificates from previous studies.",
        imgSrc: "/acadmic.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Police Clearance Certificates",
        description: "Include police clearance certificates from any country where you have resided for six months or more after the age of 18.",
        imgSrc: "/certificate.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Custodian Declaration (If Required)",
        description: "Provide a custodian declaration form if you are a minor or require guardianship while studying in Canada.",
        imgSrc: "/visits.JPG",
      },
      {
        href: "#", // Update this if needed
        title: "Completed Study Permit Application Form",
        description: "Fill out and include the completed application form for a Canadian study permit.",
        imgSrc: "/transit.JPG",
      },
      {
        href: "#", // Update this if needed
        title: "Proof of Payment",
        description: "Submit the receipt or proof of payment for the study permit application fee.",
        imgSrc: "/air.jpg",
      },
    ].map((resource, index) => (
      <div
        key={index}
        data-aos="fade-up"
        className="2xl:w-[400px] 2xl:mt-9 group relative h-auto w-80 overflow-hidden rounded-3xl border border-black font-sans hover:shadow-lg"
      >
        <a href={resource.href} className="block">
          <div className="px-2 py-2">
            <div className="2xl:w-[380px] 2xl:h-[250px] relative h-[190px] w-[300px] overflow-hidden rounded-2xl">
              <img
                src={resource.imgSrc}
                alt={resource.title}
                className="absolute left-0 top-0 object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>
          </div>
          <div className="p-8">
            <h3 className="font-syne mb-2 text-[20px] font-medium text-[#011473]">
              {resource.title}
            </h3>
            <p className="text-sm font-medium text-black">
              {resource.description}
            </p>
          </div>
        </a>
      </div>
    ))}
  </div>
</div>

      </div>
      <p className="mb-5  w-full text-left text-2xl font-bold text-[#011473] sm:ml-16 sm:w-2/3 md:text-3xl lg:ml-32">
        Why Choose Visa World Immigration Services?
      </p>
      <div className=" space-y-4 text-left sm:ml-16 sm:text-left md:text-left lg:ml-32">
        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-lg">
            Expert Guidance on Education Choices
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-lg">
            Application Support
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-lg">
            Comprehensive Visa Assistance
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-lg">
            End-to-End Migration Services
          </span>
        </div>

        <div className="flex items-center">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700 sm:text-base lg:text-lg">
            Choose Visa World for a Seamless Journey
          </span>
        </div>
      </div>
      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center justify-center text-black rounded-md bg-gray-100 p-4 text-lg shadow-md">
            <p>
              <br />- <strong>Global Recognition of Qualifications:</strong>{" "}
              Qualifications earned in Canada are highly valued internationally,
              opening doors to career opportunities worldwide.
              <br />- <strong>Affordable Education:</strong> Canadian education
              is known for its affordability, providing quality learning
              experiences without the high price tag often associated with other
              international education systems.
              <br />- <strong>Multicultural Society:</strong> Canada is a
              melting pot of cultures, offering a rich and diverse environment
              where students can thrive and engage with people from all over the
              world.
              <br />- <strong>Safe and Healthy Communities:</strong> Canada is
              renowned for its safe, clean and welcoming communities, providing
              students with a secure and supportive environment to live and
              study.
              <br />- <strong>Stipend Internships:</strong> Many programs in
              Canada offer internship opportunities with stipends, allowing
              students to gain hands-on experience while studying.
              <br />- <strong>Post-Study Work Visa:</strong> Graduates have the
              opportunity to apply for a post-study work visa, which provides
              valuable time to gain work experience in Canada after completing
              their studies.
              <br />- <strong>Pathway to Permanent Residency:</strong> Canada
              offers multiple pathways for students to transition from study
              permits to permanent residency, opening the door to long-term
              opportunities in the country.
              <br />
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="w-2/2 flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 md:w-1/2"
        >
          Why Study in Canada?
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div> 
      |
      <Contacts />
    </>
  );
};

export default Canadastudentvisa;
